import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { ManageRestaurantReports, ManageSeperateRestaurantReport } from "./logic";
import {
  showMessage,
  getToken,
  ManageRestaurant,
  formatAMPM,
  random_rgba,
} from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { is_franchise_admin, is_franchise_manager, is_franchise_staff, is_superuser, protocol } from "../../Functionalities/Config";
import NoDataComponent from '../../CoreComponents/NoDataComponent'
import LoadingComponent from "../../CoreComponents/LoadingComponent";
function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [seperateData, setSeperateData] = useState({
    total_remaining_amount: "",
    total_recived_amount: "",
    total_balance_amount: ""

  })
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true)
  const [filter, setfilter] = useState({
    branch_id: "",
    from_date: "",
    to_date: "",
  });
  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });

  useEffect(() => {
    fetchSeperateTotalTransaction()
  }, [filter.branch_id]);

  useEffect(() => {
    !(is_franchise_admin || is_franchise_manager || is_franchise_staff) && fetchData()
    (is_franchise_admin || is_franchise_manager || is_franchise_staff) && getBranches();
  }, [])

  let params =
    "branch_id=" +
    filter.branch_id +
    "&from_date=" +
    filter.from_date +
    "&to_date=" +
    filter.to_date;
  // "&for_dropdown=true&page_wise=false";


  const fetchData = () => {
    let result = ManageRestaurantReports("", "", "get", params);
    result.then((result) => {
      if (result) {
        setData({
          ...data,
          data: result.data.results,
        });
        setLoading(false)
        setNext(result.data.next);
        setPrev(result.data.previous);
      }


    });
  };

  const fetchSeperateTotalTransaction = () => {
    let param = `branch_id=${filter.branch_id}&keyword=branch_balance`

    let result = ManageSeperateRestaurantReport("", "", "get", (is_franchise_admin || is_franchise_manager || is_franchise_staff) ?
      filter.branch_id == "" ? "keyword=branch_balance" : param : "");
    result.then((result) => {
      if (result) {
        setSeperateData({
          ...seperateData,
          total_remaining_amount: result.data.total_remaining_amount,
          total_recived_amount: result.data.total_recived_amount,
          total_balance_amount: result.data.total_balance_amount

        });
        setLoading(false)
        // setNext(result.data.next);
        // setPrev(result.data.previous);
      }


    });
  }

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const getBranches = () => {
    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom", "bottom-left",
      0
    );

    let params = "for_dropdown=true&page_wise=false";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {

        // showMessage(
        //   JSON.stringify(result),
        //   "success",
        //   "Loading",
        //   "top",
        //   "top-center",
        //   0
        // );
        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
        setLoading(false)
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  return (
    <div class="content-body">
      {
        !loading ?
          <div class="container-fluid">
            <FilterModalComponent
              heading={"Filter Restaurant Reports"}
              fromDateValue={filter.from_date?.slice(0, 10)}
              fromDateChange={(e) => {
                setfilter({
                  ...filter,
                  from_date: e.target.value + " 00:00:00",
                });
              }}
              toDateValue={filter.to_date?.slice(0, 10)}
              toDateChange={(e) => {
                setfilter({
                  ...filter,
                  to_date: e.target.value + " 00:00:00",
                });
              }}
              clearFilter={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              submitFilter={(e) => {
                e.preventDefault();
                fetchData();
              }}
            >
              {( is_franchise_admin || is_franchise_manager || is_franchise_staff) && (
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Restaurant <span className="required"></span>
                    </label>
                    <select
                      value={filter.branch_id}
                      class="form-control form-control-lg"
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          branch_id: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                  </option>
                      {restrarent?.data?.map((item) => (
                        <option value={item.id} id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </FilterModalComponent>

            {
              data.data.length > 0 ?
                <>
                  <FilterComponent
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    next={next}
                    prev={prev}
                    filterButtonName={"Filter"}
                    export={data.data}
                    type="restaurant"
                  />

                  <div className="col-lg-12">
                    <div className="form-group">
                      <h4 className="fs-20 font-w600 text-center">Total Transactions Amount</h4>

                      <div className="row" style={{ marginTop: 10 }}>
                        <div className="table-responsive rounded card text-center">
                          
                          <table
                            className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                            id="example5"
                          >
                            <thead>
                              <tr>
                                <th>Transaction</th>
                                <th>From foodoor</th>
                                {( is_franchise_admin || is_franchise_manager || is_franchise_staff) && <th>To Restaurant</th>}
                                <th>Balance to {( is_franchise_admin || is_franchise_manager || is_franchise_staff) ? "pay" : "get"}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Amount</td>
                                <td>₹
                               {seperateData.total_remaining_amount}
                                </td>
                                { (is_franchise_admin || is_franchise_manager || is_franchise_staff) && <td>{seperateData.total_recived_amount}</td>}
                                <td>
                                  ₹ {
                                    seperateData.total_balance_amount
                                    // data.data[0].balance
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="table-responsive rounded card-table">
                        <div id="example5_wrapper" class="dataTables_wrapper no-footer">
                          <table
                            className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                            id="example5"
                          >
                            <thead>
                              <tr>
                                <th>REPORT ID</th>
                                <th>RESTAURANT</th>
                                <th>DATE</th>
                                <th>DESCRIPTION</th>
                                <th>FROM BELLY</th>
                                {(is_franchise_admin || is_franchise_manager || is_franchise_staff) && <th>TO RESTAURANT</th>}
                                <th>BALANCE</th>
                                {/* <th>Paid Amt</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {
                                data.data.map((report, index) => {
                                  return (
                                    <tr className="alert alert-dismissible border-0" style={{ backgroundColor: report.amount_in ? "rgba(199, 235, 255,0.1)" : "rgba(255, 249, 199,0.1)" }}>
                                      <td>
                                        {/* <a href={`/orderID/${item.id} `}> #{item.id}</a> */}
                              RSTRPT{report.id}
                                      </td>
                                      <td>
                                        <a href={`/restaurant/${report.branch.id} `}>
                                          <h5 className="mb-0 fs--1">
                                            {report.branch.name}
                                          </h5>
                                        </a>
                                      </td>
                                      <td>
                                        {new Date(report.date).toLocaleDateString()}<br />{formatAMPM(new Date(report.date))}
                                      </td>
                                      <td>{report.discription}</td>

                                      <td>
                                        <b class="text text-primary">
                                          {( is_franchise_admin || is_franchise_manager || is_franchise_staff) ? report.amount_in ? `₹ ${report.amount_in}` : "---" : report.amount_out}
                                        </b>
                                      </td>
                                      {( is_franchise_admin || is_franchise_manager || is_franchise_staff) &&
                                        <td>
                                          <b class="text text-secondary">
                                            {report.amount_out ? `₹ ${report.amount_out}` : "---"}
                                          </b>
                                        </td>}
                                      <td>
                                        <b class="text text-danger">₹ {report.balance}</b>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>

                            {data.data.length > 0 &&
                              <thead>
                                <tr>
                                  <th>Total</th>
                                  <th>---</th>
                                  <th>---</th>
                                  <th>---</th>

                                  <th>₹
                        {
                                      ( is_franchise_admin || is_franchise_manager || is_franchise_staff) ?
                                        data.data.reduce(function (tot, arr) {
                                          return tot + arr.amount_in
                                        }, 0).toFixed(2)
                                        :
                                        data.data.reduce(function (tot, arr) {
                                          return tot + arr.amount_out
                                        }, 0).toFixed(2)
                                    }
                                  </th>
                                  <th>
                                    {
                                      ( is_franchise_admin || is_franchise_manager || is_franchise_staff) ? "₹ " +
                                        data.data.reduce(function (tot, arr) {
                                          return tot + arr.amount_out
                                        }, 0).toFixed(2)
                                        : "---"
                                    }</th>
                                  
                                  <th>---</th>
                                </tr>
                              </thead>}
                          </table>
                          <div
                            class="dataTables_paginate paging_simple_numbers"
                            id="example5_paginate"
                          >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                :
                <div style={{ width: '100%', height: 500, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {( is_franchise_admin || is_franchise_manager || is_franchise_staff) ?
                    <div
                      type="submit"
                      data-toggle="modal"
                      data-target="#sendFilterModal"
                      style={{}}
                      className="btn btn-primary mb-1 btn-rounded"
                      id="timepicker"
                    >
                      No Transaction Found {filter.branch_id !== "" && "in this Hotel"} , Please Select {filter.branch_id !== "" && "Another "}Hotel
            </div>
                    :
                    <div
                      type="submit"
                      data-toggle="modal"
                      data-target="#sendFilterModal"
                      style={{}}
                      className="btn btn-primary mb-1 btn-rounded"
                      id="timepicker"
                    >
                      No Transaction Found
            </div>
                  }
                </div>
            }


          </div>
          : <LoadingComponent />
      }  </div>
  );
}

function RestaurantReports() {
  return (
    <div id="main-wrapper">
      <MainHeader />
      <Header
        name={"Restaurant Reports"}
        subHeading={"All  Restaurants Transaction Reports"}
      />
      <NavBar />
      <Body />
      <Footer />
    </div>
  );
}

export default RestaurantReports;
